<script setup lang="ts">
	const { messages: toastMessages } = useToast();
</script>

<template>
	<NuxtLayout>
		<NuxtPage />
		<AppToast :messages="toastMessages" />
	</NuxtLayout>
</template>

<style lang="scss"></style>
